// extracted by mini-css-extract-plugin
export default {"circle":"point-module___circle___b2572c7c","editMode":"point-module___editMode___bf70c688"};